<template>
    <card>
    <div class="header">
        <button title='Adicionar Item' @click.prevent.stop='add()' class="pull-right btn btn-sm btn-success btn-icon"><i class="fa fa-plus"></i></button>
        <h4 class="title">Itens</h4>
    </div>
    <div class='content'>
      <ul class="list-unstyled team-members">
          <li v-for='(item,index) in items' :key='`item-${index}`'>
              <div class="row">
                  <div class="col-xs-6 col-5">
                      <span v-if='!item.removido'>{{item.codigo}}</span>
                      <s v-else>{{item.codigo}}</s>
                      <br />
                      <span v-if='!item.removido' class="text-muted"><small>Disponível no Acervo</small></span>
                      <span v-else class="text-muted"><small>Removido</small></span>
                  </div>

                  <div class="col-xs-3 col-4 text-right" style="display: flex;align-items: center;">
                    <span class="mr-2">Restrito</span>
                    <span >
                    <label class="switch">                        
                      <input @input.stop.prevent='toggleRestrito(item)' type="checkbox" v-model='item.restrito'>
                      <span class="slider round"></span>
                    </label>

                    </span>
                  </div>

                  <div class="col-xs-3 text-right">
                      <button v-if='!item.removido' title='Remover do acervo' @click.prevent.stop='toggleRemove(item)'  class="btn btn-sm btn-danger btn-icon"><i class="fa fa-times"></i></button>
                      <button v-else title='Recolocar no acervo' @click.prevent.stop='toggleRemove(item)' class="btn btn-sm btn-success btn-icon"><i class="fa fa-plus"></i></button>
                  </div>
              </div>
          </li>
      </ul>
    </div>
</card>
</template>
<script>
export default {

  props: {
    items: Array
  },

  methods: {
    toggleRemove (item) {
      this.$emit('edit', { removido: !item.removido, id: item.id })
    },

    toggleRestrito (item) {
      this.$emit('edit', { restrito: !item.restrito, id: item.id })
    },

    add () {
      this.$emit('add')
    }
  }

}
</script>
<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>